import config from '@/config'
import axios from "axios"
import {Message} from "element-ui"
import store from "@/store"
import {getToken,setToken} from "@/utils/libs"
import _ from "lodash"
import qs from 'qs';

//判断运行环境
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

const http=axios.create({
    baseURL:baseUrl,
    timeout:"30000"
})

// 添加请求拦截器
// 添加请求拦截器
http.interceptors.request.use(function (config) {
    if (config.method === "post" && config.headers['Content-Type'] != 'multipart/form-data'){
        config.headers['Content-Type'] == 'application/x-www-form-urlencoded'
        config.data = qs.stringify(config.data);
    }
    let token = getToken();
    config.headers['token'] = token;
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
    let data = response.data
    if (data.code =="1001") {
        Message.error(data.info)
        setToken('')
        setTimeout(() => {
            window.location.reload()
        }, 2000)
        return
    }else{
        return response.data;
    }
    
}, function (error) {
    // 处理错误
    if(_.has(error, 'response.status')) {
        switch (error.response.status) {
            case 401:
                error.message = '未授权，请登录';
                break;
            case 403:
                error.message = '拒绝访问';
                break;
            case 500:
                error.message = '服务器内部错误';
                break;
            case 404:
                error.message = `请求地址不存在：${error.response.config.url}`;
                break;
            default:
                error.message = error.response.data.errorMessage;
        }
    }
    Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    return Promise.reject(error);
});


export default http;


// WEBPACK FOOTER //
// ./src/api/axios.js